import { VueEditor } from 'vue2-editor'
import codes from '@/codes';
// import PrismEditor from 'vue-prism-editor'
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';

import { codemirror } from 'vue-codemirror'

import dedent from 'dedent'
// require styles
import 'codemirror/lib/codemirror.css'
// theme css
import 'codemirror/theme/base16-dark.css'

// language
import 'codemirror/mode/vue/vue.js'

import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/match-highlighter.js'
// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
// foldGutter
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'

//restful api
import { auth } from '@/service';
import { policy as webcastle } from '@/service/api/webcastle'

export default {
  components: { cSwitch, VueEditor, codemirror },
  data : () => {
    return {
      last_version : '',
      auth,
      // lock : false,
      lock : true,
      model : {},
      parnter_name : '',
      codes,
      reload : true,
      init : '',
      confirm_remove : false,
      confirm_update : false,
      json_validation : false,
      // codemirror options
      options_rule: {
        tabSize: 4,
        // mode: 'text',
        theme: 'base16-dark',
        lineNumbers: true,
        line: true,
        mode: 'text/javascript',
        lineWrapping: true,
      },
      options_json: {
        tabSize: 4,
        theme: 'base16-dark',
        lineNumbers: true,
        line: true,
        mode: 'text/javascript',
        lineWrapping: true,
      }
    }
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.html); // languages.<insert language> to return html with markup
    },
    refresh(id) {
      this.$router.push({ name: 'webcastle.policy', params : { id : id ? id : this.model.id } });
    },
    change(content) {
      this.model = Object.assign({}, this.model, { crs_rule : content })
    },
    change_json(content) {
      this.model = Object.assign({}, this.model, { crs_json : content })
      this.json_validation = true
      try { JSON.parse(content.toString())  } catch (e) { console.log("is not json format"); this.json_validation = false }

    },
    list() { this.$router.push({ name: 'webcastle_policy'}); this.$emit('refresh'); },
    async get({ id } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; this.latest(); this.model.is_alive = true; return; }
      try {
        let rs = await webcastle.detailPolicy({ id : id });
        if(rs.error) { return this.$toastr.e("load failed") }
        this.model = Object.assign({}, this.model, rs.body)
        this.json_validation = true
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    async remove() {
      try {
        let rs = await webcastle.deletePolicy({ id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed', this.$route.name);
          this.list();
        } else {
          this.$toastr.e('Remove', "failed");
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    async save() {
      try {
        if(!(this.model.version || '').trim()) { return this.$toastr.e("version", "require") }
        if(!(this.model.crs_rule || '').trim()) { return this.$toastr.e("Rule", "require") }
        if(!(this.model.crs_json || '').trim()) { return this.$toastr.e("Rule JSON", "require") }
        if(!this.json_validation) { return this.$toastr.e("Rule JSON", "require json format") }

        let check_id = '';
        check_id = this.model.id ? `${await webcastle.updatePolicy(this.model)}` : `${await webcastle.insertPolicy(this.model)}`;

        let rs = check_id;
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.model = Object.assign({}, this.model, rs.body)
            rs.body
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      this.lock = true;
    },
    async latest() {
      try {
        let rs = await webcastle.latestPolicy();
        if(!rs.error) {
          this.last_version = rs.body
        } else {
          this.$toastr.e('last version load failed');
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async edit(){
      this.lock = false;
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('webcastle.policy.detail.vue', 'created'); },
  destroyed: function() { console.log('webcastle.policy.detail.vue', 'destroyed'); },
  mounted: function() { console.log('webcastle.policy.detail.vue', 'mounted'); this.get(this.$route.params);},
}
